export const categories = [
  {
    id: 'plantation',
    name: '水蜜桃种植',
    slug: 'plantation',
    icon: 'ri-seedling-line',
    description: '从选苗到修剪，从施肥到防虫，分享水蜜桃种植的全流程技术与果园管理经验。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20peach%20orchard%20in%20spring%20with%20blooming%20peach%20blossoms%2C%20rows%20of%20fruit%20trees%20on%20gentle%20hills%2C%20soft%20morning%20light%2C%20professional%20agricultural%20photography%2C%20clean%20and%20fresh%20atmosphere%2C%20warm%20natural%20colors&width=800&height=480&seq=category-plantation&orientation=landscape',
  },
  {
    id: 'harvesting',
    name: '水蜜桃采摘',
    slug: 'harvesting',
    icon: 'ri-basketball-line',
    description: '跟随镜头走进果园，记录水蜜桃采摘的每一个精彩瞬间，体验丰收的喜悦。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Ripe%20juicy%20peaches%20being%20hand%20picked%20from%20orchard%20trees%2C%20wooden%20baskets%20filled%20with%20fresh%20peaches%2C%20golden%20summer%20afternoon%20light%2C%20editorial%20food%20photography%20style%2C%20warm%20and%20inviting%20atmosphere%2C%20clean%20composition&width=800&height=480&seq=category-harvesting&orientation=landscape',
  },
  {
    id: 'tasting',
    name: '水蜜桃品鉴',
    slug: 'tasting',
    icon: 'ri-emotion-happy-line',
    description: '专业品鉴各类水蜜桃品种，从外观、香气、甜度到口感，全方位评测。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Elegant%20arrangement%20of%20multiple%20peach%20varieties%20on%20a%20wooden%20tasting%20board%2C%20close%20up%20of%20cut%20peaches%20showing%20juicy%20flesh%2C%20soft%20natural%20window%20lighting%2C%20food%20magazine%20style%20photography%2C%20sophisticated%20warm%20tones&width=800&height=480&seq=category-tasting&orientation=landscape',
  },
  {
    id: 'cuisine',
    name: '水蜜桃美食',
    slug: 'cuisine',
    icon: 'ri-cake-3-line',
    description: '水蜜桃甜品、饮品、创意料理全攻略，教你用桃子做出令人惊艳的美味。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20peach%20dessert%20on%20elegant%20ceramic%20plate%2C%20peach%20tart%20with%20fresh%20peach%20slices%2C%20soft%20warm%20kitchen%20lighting%2C%20food%20photography%20with%20shallow%20depth%20of%20field%2C%20appetizing%20and%20artistic%20composition%2C%20warm%20creamy%20tones&width=800&height=480&seq=category-cuisine&orientation=landscape',
  },
  {
    id: 'livestream',
    name: '果园直播',
    slug: 'livestream',
    icon: 'ri-live-line',
    description: '实时连线果园现场，带你感受最真实的水蜜桃生长环境与果园日常。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Expansive%20peach%20orchard%20landscape%20under%20blue%20sky%20with%20white%20clouds%2C%20green%20trees%20with%20ripening%20fruit%2C%20wide%20angle%20scenic%20view%2C%20natural%20documentary%20photography%20style%2C%20vibrant%20and%20fresh%20countryside%20atmosphere&width=800&height=480&seq=category-livestream&orientation=landscape',
  },
];

export const articles = [
  {
    id: 1,
    title: '阳山水蜜桃的百年种植传奇：从一棵树到万亩桃园',
    slug: 'yangshan-peach-century-story',
    categorySlug: 'plantation',
    categoryName: '水蜜桃种植',
    excerpt: '无锡阳山，这片被太湖水滋润的土地，孕育了中国最负盛名的水蜜桃。从清末引进第一棵桃树开始，阳山水蜜桃走过了百余年的风雨历程。',
    content: '<p>无锡阳山，这片被太湖水滋润的土地，孕育了中国最负盛名的水蜜桃。从清末引进第一棵桃树开始，阳山水蜜桃走过了百余年的风雨历程，如今已发展成为种植面积超过3万亩的支柱产业。</p><h2>百年桃源的起源</h2><p>阳山水蜜桃的种植历史可追溯至清朝光绪年间。当时，一位名叫张福兴的果农从浙江奉化引进了第一批水蜜桃苗，在阳山脚下的火山灰土壤中试种。这种独特的土壤富含矿物质，加上太湖调节的温和气候，为水蜜桃的生长创造了得天独厚的条件。</p><p>经过几代果农的精心选育，阳山水蜜桃逐渐形成了白凤、湖景、朝晖等多个优良品种。其中白凤桃以果大、汁多、味甜而闻名，单个果实重量可达400克以上，被誉为"桃中之王"。</p><h2>独特的种植技艺</h2><p>阳山果农们在长期实践中总结出了一套独特的水蜜桃种植技艺。春季修剪讲究"三枝六杈十二梢"的树形结构，确保每片叶子都能充分接受阳光。夏季套袋是水蜜桃品质保障的关键环节，采用特制的防水纸袋，既能防虫防病，又不会影响果实的正常呼吸。</p><p>施肥方面，阳山果农坚持使用有机肥为主，配以菜籽饼、豆饼等天然肥料。这种传统施肥方式虽然成本较高，但培育出的水蜜桃风味更加浓郁，甜度可达14度以上。</p><h2>现代科技赋能传统农业</h2><p>近年来，阳山水蜜桃产业积极拥抱现代科技。物联网传感器遍布桃园，实时监测土壤湿度、温度、光照等数据；无人机用于喷洒生物农药，精准高效；冷链物流体系确保水蜜桃在采摘后24小时内送达消费者手中。</p><p>2023年，阳山水蜜桃获得国家地理标志保护产品认证，品牌价值超过80亿元。从一棵桃树到万亩桃园，阳山水蜜桃的故事，是中国现代农业发展的生动缩影。</p>',
    author: '果园老张',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20elderly%20farmer%20portrait%20with%20warm%20smile%2C%20professional%20headshot%20style%2C%20soft%20natural%20light%2C%20clean%20background%2C%20friendly%20and%20wise%20expression&width=120&height=120&seq=avatar-zhang&orientation=squarish',
    publishDate: '2026-07-15',
    readTime: '8分钟',
    coverUrl: 'https://readdy.ai/api/search-image?query=Vast%20peach%20orchard%20in%20Yangshan%20Wuxi%20at%20golden%20hour%2C%20rows%20of%20peach%20trees%20heavy%20with%20ripe%20pink%20peaches%2C%20distant%20mountains%20silhouette%2C%20warm%20amber%20sunset%20light%2C%20cinematic%20agricultural%20landscape%20photography%2C%20breathtaking%20natural%20scenery&width=800&height=480&seq=article-yangshan&orientation=landscape',
    tags: ['阳山水蜜桃', '种植历史', '果园管理'],
    featured: true,
  },
  {
    id: 2,
    title: '水蜜桃采摘全攻略：什么时候摘？怎么摘才不伤果？',
    slug: 'peach-harvesting-complete-guide',
    categorySlug: 'harvesting',
    categoryName: '水蜜桃采摘',
    excerpt: '水蜜桃的采摘时机和手法直接决定了果实的品质和储存时间。掌握正确的采摘技巧，才能让每一颗桃子都完美呈现。',
    content: '<p>水蜜桃的采摘时机和手法直接决定了果实的品质和储存时间。很多人在果园采摘时，往往因为方法不当导致果实损伤，影响口感和品相。今天我们就来详细讲解水蜜桃采摘的全套技巧。</p><h2>判断采摘时机</h2><p>水蜜桃的成熟度判断有"一看二摸三闻"的口诀。一看果皮颜色：成熟的水蜜桃底色由青转白或黄，阳面呈现红晕；二摸果实硬度：用手指轻轻按压果实肩部，有轻微弹性即为适采期；三闻果香：成熟的水蜜桃会散发出浓郁的果香。</p><p>不同品种的采摘标准也略有差异。白凤桃在七八分熟时采摘最佳，湖景桃则适宜在八九分熟时采摘。采摘时间最好选择在清晨5点至9点之间，此时果实温度低，呼吸作用弱，有利于后续保鲜。</p><h2>正确的采摘手法</h2><p>采摘水蜜桃时，切忌直接拉扯果实。正确的方法是：用整个手掌托住果实底部，轻轻向上旋转，使果梗与果枝自然分离。注意不要用手指按压果面，避免留下指痕。</p><p>采摘后应轻拿轻放，将果实放入铺有软垫的采摘篮中。每个篮子不宜装得太满，一般装到八分满即可，防止上层果实压伤下层果实。</p><h2>采摘后的处理</h2><p>采摘后的水蜜桃应尽快进行预冷处理，将果心温度降至4-5℃。家庭采摘可以用湿毛巾覆盖果实，放在阴凉通风处。如果需要长途运输，建议使用泡沫网套和瓦楞纸箱进行包装，并加入冰袋保持低温。</p><p>掌握了这些采摘技巧，你也能像专业果农一样，完美采摘每一颗水蜜桃，留住最鲜美的味道。</p>',
    author: '采摘达人小李',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20farmer%20with%20warm%20smile%20holding%20fresh%20peaches%2C%20portrait%20in%20orchard%20setting%2C%20natural%20daylight%2C%20friendly%20and%20approachable%2C%20lifestyle%20photography&width=120&height=120&seq=avatar-li&orientation=squarish',
    publishDate: '2026-07-10',
    readTime: '6分钟',
    coverUrl: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20gently%20picking%20a%20ripe%20peach%20from%20tree%20branch%20in%20orchard%2C%20golden%20morning%20sunlight%20filtering%20through%20leaves%2C%20shallow%20depth%20of%20field%2C%20editorial%20agricultural%20photography%2C%20warm%20and%20intimate%20atmosphere&width=800&height=480&seq=article-harvesting&orientation=landscape',
    tags: ['采摘技巧', '果园体验', '果实保鲜'],
    featured: true,
  },
  {
    id: 3,
    title: '五大水蜜桃品种横向评测：白凤、湖景、朝晖谁更胜一筹？',
    slug: 'top-5-peach-varieties-review',
    categorySlug: 'tasting',
    categoryName: '水蜜桃品鉴',
    excerpt: '我们挑选了市面上最受欢迎的五个水蜜桃品种，从外观、香气、甜度、汁水和口感五个维度进行专业评测，帮你找到最适合自己的那一款。',
    content: '<p>每年六至八月是水蜜桃的黄金季节，市场上琳琅满目的品种让人眼花缭乱。我们精心挑选了白凤、湖景蜜露、朝晖、霞晖和雨花露五大品种，进行了一次全面的横向对比评测。</p><h2>评测标准说明</h2><p>本次评测从五个维度进行评分（满分10分）：外观品相、果香浓郁度、甜度（实测糖度）、汁水丰富度、口感风味。所有样品均在相同成熟度条件下进行评测，确保公平性。</p><h2>白凤桃：经典之选</h2><p>白凤桃果形端正，平均单果重350克，果皮乳白带粉红晕。香气清雅持久，实测糖度13.8度，汁水极为丰富，咬一口果汁四溢。口感细腻软糯，几乎没有纤维感。综合评分：9.2分，依然是水蜜桃界的标杆。</p><h2>湖景蜜露：甜度之王</h2><p>湖景蜜露果实略小于白凤，但甜度惊人，实测糖度高达15.2度。果肉呈乳黄色，质地紧密，汁水适中。最大的特点是蜜香味浓郁，入口有一种独特的蜂蜜回甘。综合评分：9.0分。</p><h2>朝晖：颜值担当</h2><p>朝晖桃外观最为艳丽，果皮鲜红面积超过70%，非常上镜。果肉较脆，甜度13.2度，水分适中。适合喜欢脆桃口感的消费者，也适合用于烘焙和制作甜品。综合评分：8.5分。</p><h2>霞晖与雨花露</h2><p>霞晖桃是早熟品种，六月中旬即可上市，甜度12.5度，香气清新。雨花露则是晚熟品种，八月中下旬成熟，耐储存性较好。两款各有特色，适合不同时间段的消费需求。</p>',
    author: '品鉴师阿桃',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20food%20critic%20portrait%2C%20professional%20yet%20warm%20expression%2C%20tasteful%20studio%20lighting%2C%20clean%20white%20background%2C%20sophisticated%20and%20approachable&width=120&height=120&seq=avatar-tao&orientation=squarish',
    publishDate: '2026-07-05',
    readTime: '7分钟',
    coverUrl: 'https://readdy.ai/api/search-image?query=Five%20different%20varieties%20of%20fresh%20peaches%20arranged%20in%20a%20row%20on%20a%20rustic%20wooden%20surface%2C%20each%20cut%20in%20half%20showing%20different%20flesh%20colors%2C%20natural%20side%20lighting%2C%20food%20magazine%20editorial%20style%2C%20detailed%20texture%20visible%2C%20warm%20organic%20colors&width=800&height=480&seq=article-tasting&orientation=landscape',
    tags: ['品种评测', '水蜜桃品鉴', '口感对比'],
    featured: true,
  },
  {
    id: 4,
    title: '夏日限定：蜜桃乌龙茶冻，清凉一夏的高颜值甜品',
    slug: 'peach-oolong-tea-jelly-recipe',
    categorySlug: 'cuisine',
    categoryName: '水蜜桃美食',
    excerpt: '把成熟的水蜜桃和清香的乌龙茶结合，做成一款晶莹剔透的茶冻甜品。Q弹爽滑，茶香桃韵，是夏日午后的完美享受。',
    content: '<p>盛夏时节，水蜜桃和乌龙茶的组合简直是天作之合。今天分享的这款蜜桃乌龙茶冻，制作简单但颜值超高，绝对是朋友圈的吸赞利器。</p><h2>食材准备</h2><p>成熟水蜜桃2个、乌龙茶叶10克、白凉粉30克、冰糖40克、清水600毫升、柠檬汁少许。</p><h2>制作步骤</h2><p>第一步：将乌龙茶叶用80℃热水冲泡3分钟，滤出茶汤备用。茶汤颜色以琥珀色为佳，太浓会影响桃味，太淡则茶香不足。</p><p>第二步：一个水蜜桃去皮切丁，另一个榨汁。将桃汁与茶汤混合，加入冰糖和少许柠檬汁。柠檬汁不仅能提鲜，还能防止桃汁氧化变色。</p><p>第三步：将混合液加热至微沸，缓缓倒入白凉粉，不停搅拌至完全溶解。注意火候不要太大，保持中小火即可。</p><p>第四步：在模具底部铺上桃丁，倒入茶冻液，放入冰箱冷藏3小时以上。脱模时可用热毛巾敷一下模具外壁，即可轻松脱出。</p><h2>摆盘与享用</h2><p>脱模后的茶冻晶莹剔透，可以看到里面镶嵌的桃肉丁。可以搭配少许椰奶或炼乳，再点缀一片薄荷叶，颜值瞬间拉满。入口Q弹爽滑，先是乌龙茶的清香，然后是水蜜桃的甜美，层次分明又和谐统一。</p>',
    author: '甜品师糖糖',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20pastry%20chef%20in%20clean%20white%20uniform%2C%20gentle%20smile%2C%20professional%20kitchen%20background%2C%20warm%20soft%20lighting%2C%20elegant%20and%20professional&width=120&height=120&seq=avatar-tang&orientation=squarish',
    publishDate: '2026-06-28',
    readTime: '5分钟',
    coverUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20peach%20oolong%20tea%20jelly%20dessert%20on%20a%20white%20ceramic%20plate%2C%20crystal%20clear%20amber%20colored%20jelly%20with%20peach%20pieces%20inside%2C%20garnished%20with%20mint%20leaf%2C%20soft%20natural%20window%20light%2C%20food%20magazine%20photography%2C%20elegant%20and%20refreshing&width=800&height=480&seq=article-cuisine&orientation=landscape',
    tags: ['水蜜桃甜品', '美食制作', '夏日食谱'],
    featured: false,
  },
  {
    id: 5,
    title: '桃园二十四节气：惊蛰到春分，桃树苏醒的黄金管理期',
    slug: 'peach-orchard-solar-terms-spring',
    categorySlug: 'plantation',
    categoryName: '水蜜桃种植',
    excerpt: '惊蛰过后，桃树从休眠中苏醒，进入萌芽期。这段时间的管理至关重要，直接关系到全年的产量和品质。',
    content: '<p>在中国传统农耕文化中，二十四节气是农事活动的重要指南。对于水蜜桃种植来说，惊蛰到春分这段时间尤为关键，是桃树从休眠转入生长的过渡期。</p><h2>惊蛰：唤醒沉睡的桃树</h2><p>惊蛰时节，气温回升至10℃以上，桃树根系开始活动，树液开始流动。此时需要做的第一件事是浇灌"萌芽水"。选择晴暖天气，浇透一次水，促进根系吸收养分。但要注意水量不能过多，以免降低地温。</p><p>第二项重要工作是施萌芽肥。以速效氮肥为主，配合适量的磷钾肥。每棵成年桃树施用尿素0.3-0.5公斤，过磷酸钙0.5公斤，硫酸钾0.2公斤。施肥后及时覆土浇水，提高肥料利用率。</p><h2>春分前：病虫害防治窗口期</h2><p>春分前是桃树病虫害防治的关键窗口期。桃蚜是春季最常见的害虫，在花芽膨大期就开始危害。建议使用石硫合剂进行全面喷洒，既能杀虫又能防病。喷洒时要做到均匀周到，树干、枝条、地面都要覆盖到。</p><p>此外，此时也是修剪的最佳时期之一。重点疏除过密枝、交叉枝和病虫枝，保持树冠通风透光。修剪后用伤口愈合剂涂抹剪口，防止病菌侵入。</p>',
    author: '果园老张',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20elderly%20farmer%20portrait%20with%20warm%20smile%2C%20professional%20headshot%20style%2C%20soft%20natural%20light%2C%20clean%20background%2C%20friendly%20and%20wise%20expression&width=120&height=120&seq=avatar-zhang&orientation=squarish',
    publishDate: '2026-06-20',
    readTime: '6分钟',
    coverUrl: 'https://readdy.ai/api/search-image?query=Early%20spring%20peach%20orchard%20with%20young%20buds%20on%20bare%20branches%2C%20morning%20dew%20drops%20on%20twigs%2C%20soft%20diffused%20spring%20light%2C%20misty%20atmosphere%2C%20agricultural%20documentary%20photography%2C%20fresh%20and%20hopeful%20mood%2C%20gentle%20warm%20tones&width=800&height=480&seq=article-spring&orientation=landscape',
    tags: ['春季管理', '二十四节气', '种植技术'],
    featured: false,
  },
  {
    id: 6,
    title: '桃酱的100种吃法：从早餐吐司到晚餐烤肉的神奇搭配',
    slug: 'peach-jam-100-ways',
    categorySlug: 'cuisine',
    categoryName: '水蜜桃美食',
    excerpt: '自制水蜜桃果酱不仅健康美味，还能搭配出无穷创意。从经典早餐到创意料理，桃酱让你的餐桌充满惊喜。',
    content: '<p>每年水蜜桃季，我都会熬上几大罐桃酱，封存夏天的味道。一罐好的手工桃酱，不只是一抹甜味，更是一整个季节的记忆。</p><h2>基础桃酱制作</h2><p>选用成熟度适中的水蜜桃5个，去皮去核切小块。加入白砂糖200克、柠檬汁半个。中火熬煮，不断搅拌防止粘锅。熬至果肉透明、酱体浓稠即可。装瓶前确保玻璃瓶已消毒，趁热装瓶倒扣，形成真空密封。</p><h2>经典搭配推荐</h2><p>烤吐司抹桃酱是最简单的幸福。如果升级一下，可以在吐司上先抹一层奶油奶酪，再铺上桃酱，撒几颗烤杏仁片，就是咖啡馆级别的早餐。</p><p>桃酱配希腊酸奶也是绝配。无糖酸奶的酸味刚好中和桃酱的甜，再加一勺格兰诺拉麦片，口感层次丰富。</p><h2>创意料理应用</h2><p>桃酱不只是甜品专属，在咸味料理中也有出色表现。烤鸡翅刷上一层桃酱，高温下焦糖化后形成琥珀色的脆皮，甜咸交织让人欲罢不能。煎猪排配上桃酱和少许芥末籽调制的酱汁，水果的酸甜让猪肉更加鲜嫩多汁。</p>',
    author: '甜品师糖糖',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20pastry%20chef%20in%20clean%20white%20uniform%2C%20gentle%20smile%2C%20professional%20kitchen%20background%2C%20warm%20soft%20lighting%2C%20elegant%20and%20professional&width=120&height=120&seq=avatar-tang&orientation=squarish',
    publishDate: '2026-06-15',
    readTime: '5分钟',
    coverUrl: 'https://readdy.ai/api/search-image?query=Homemade%20peach%20jam%20in%20a%20glass%20jar%20with%20fresh%20peaches%20and%20toast%20on%20a%20rustic%20wooden%20table%2C%20warm%20morning%20sunlight%20streaming%20through%20window%2C%20cozy%20breakfast%20scene%2C%20food%20lifestyle%20photography%2C%20inviting%20and%20homey%20atmosphere&width=800&height=480&seq=article-jam&orientation=landscape',
    tags: ['桃酱', '美食创意', '厨房技巧'],
    featured: false,
  },
  {
    id: 7,
    title: '从果园到直播间：水蜜桃电商直播的幕后故事',
    slug: 'peach-livestream-behind-scenes',
    categorySlug: 'livestream',
    categoryName: '果园直播',
    excerpt: '当水蜜桃遇上直播间，果园变成了舞台。我们走进水蜜桃直播的幕后，揭秘果农主播们的真实工作日常。',
    content: '<p>清晨五点，天还没亮，果农小王已经架好了直播设备。今天他要直播的是阳山水蜜桃的清晨采摘。"家人们早上好，我现在就在咱们的桃园里，给大家看看今天现摘的白凤桃。"</p><h2>直播间的诞生</h2><p>三年前，小王还是一个普通果农，桃子主要靠批发商收购。价格波动大，好年景也未必有好收入。一次偶然的机会，他在短视频平台发了一条摘桃子的视频，意外获得了数十万播放量。</p><p>从那以后，小王开始系统学习直播带货。从最初的结结巴巴到现在的侃侃而谈，从几十个观众到上万人在线，这条路走了整整两年。</p><h2>一场直播的准备</h2><p>一场成功的果园直播需要大量准备工作。首先是场地选择，要找光线好、桃树状态佳的片区作为直播点。设备方面需要准备手机云台、补光灯、无线麦克风，还有最重要的——充电宝。</p><p>内容策划同样重要。小王会在直播中穿插讲解水蜜桃知识、展示采摘技巧、现场试吃评测。有时候还会带着观众"云逛果园"，让大家看到桃子的真实生长环境。</p>',
    author: '新媒体人阿远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20content%20creator%20with%20modern%20casual%20style%2C%20confident%20smile%2C%20urban%20creative%20workspace%20background%2C%20natural%20lighting%2C%20contemporary%20lifestyle%20portrait&width=120&height=120&seq=avatar-yuan&orientation=squarish',
    publishDate: '2026-06-08',
    readTime: '7分钟',
    coverUrl: 'https://readdy.ai/api/search-image?query=Chinese%20farmer%20livestreaming%20in%20a%20peach%20orchard%20with%20smartphone%20on%20tripod%2C%20holding%20fresh%20peaches%2C%20golden%20hour%20sunlight%2C%20behind%20the%20scenes%20documentary%20style%2C%20authentic%20and%20warm%20atmosphere%2C%20blending%20tradition%20with%20modern%20technology&width=800&height=480&seq=article-livestream&orientation=landscape',
    tags: ['果园直播', '电商带货', '数字农业'],
    featured: true,
  },
  {
    id: 8,
    title: '水蜜桃的营养价值大揭秘：为什么说它是水果中的营养黄金？',
    slug: 'peach-nutrition-guide',
    categorySlug: 'tasting',
    categoryName: '水蜜桃品鉴',
    excerpt: '水蜜桃不仅美味多汁，更是一座营养宝库。富含维生素、矿物质和抗氧化物质，是健康饮食的理想选择。',
    content: '<p>水蜜桃被誉为"水果中的营养黄金"，这个称号可不是浪得虚名。让我们从营养学角度，全面解析水蜜桃的健康价值。</p><h2>丰富的维生素组合</h2><p>每100克水蜜桃果肉中含有维生素C约6.6毫克，虽然不是最高，但搭配其中的生物类黄酮，吸收率极佳。此外还含有维生素A前体β-胡萝卜素，对保护视力非常有益。维生素E含量在水果中也名列前茅，是天然的抗氧化能手。</p><h2>矿物质微量元素</h2><p>水蜜桃富含钾元素，每100克含有约190毫克钾，有助于维持体内电解质平衡。铁元素的含量也相当可观，对于预防缺铁性贫血有一定帮助。此外还含有锌、硒等微量元素，这些都是维持人体正常生理功能所必需的。</p><h2>膳食纤维与消化健康</h2><p>水蜜桃中的膳食纤维包括可溶性和不可溶性两种。可溶性纤维如果胶，有助于降低胆固醇；不可溶性纤维则促进肠道蠕动，预防便秘。一个中等大小的水蜜桃就能提供约2克膳食纤维。</p>',
    author: '营养师小周',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20nutritionist%20professional%20portrait%2C%20warm%20and%20trustworthy%20smile%2C%20clean%20white%20coat%2C%20bright%20modern%20clinic%20background%2C%20professional%20yet%20friendly&width=120&height=120&seq=avatar-zhou&orientation=squarish',
    publishDate: '2026-05-25',
    readTime: '6分钟',
    coverUrl: 'https://readdy.ai/api/search-image?query=Fresh%20ripe%20peach%20cut%20in%20half%20on%20a%20clean%20white%20surface%20with%20nutritional%20elements%20illustrated%20around%20it%2C%20bright%20clean%20studio%20lighting%2C%20scientific%20yet%20appealing%20food%20photography%2C%20educational%20but%20beautiful%20composition&width=800&height=480&seq=article-nutrition&orientation=landscape',
    tags: ['营养价值', '健康饮食', '水蜜桃知识'],
    featured: false,
  },
];

export const brandInfo = {
  name: '水蜜桃视频',
  slogan: '甜蜜果香记录每一刻',
  founded: '2020年',
  description: '水蜜桃视频是中国领先的水蜜桃主题短视频内容平台，创立于2020年。我们致力于用镜头记录水蜜桃从花开到结果的全过程，传播水蜜桃种植文化，分享田园生活的美好。',
  mission: '让每一个热爱生活的人，都能通过我们的视频感受到水蜜桃的甜蜜与果园的魅力。',
  teamSize: '50+人',
  videoCount: '2000+',
  usersCount: '100万+',
  partnersCount: '300+',
  contact: {
    email: 'hello@shuimitao-video.com',
    phone: '0571-8888-6666',
    address: '浙江省杭州市余杭区梦想小镇桃园路88号',
    wechat: 'shuimitao_video',
    weibo: '@水蜜桃视频官方',
  },
  testimonials: [
    {
      id: 1,
      name: '王先生',
      role: '阳山桃农',
      content: '水蜜桃视频让我们的桃子被更多人看到。去年通过平台直播，我家桃园的销售额翻了三倍！',
      avatar: 'https://readdy.ai/api/search-image?query=Chinese%20middle%20aged%20farmer%20with%20weathered%20hands%20and%20warm%20smile%2C%20outdoor%20portrait%20in%20orchard%2C%20natural%20light%2C%20honest%20and%20genuine%20expression&width=120&height=120&seq=testimonial-1&orientation=squarish',
    },
    {
      id: 2,
      name: '陈女士',
      role: '美食博主',
      content: '这里的水蜜桃美食教程太实用了！我跟着做了蜜桃乌龙茶冻，在朋友圈获得了超过200个赞。',
      avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20food%20blogger%2C%20stylish%20casual%20look%2C%20bright%20smile%2C%20cafe%20background%2C%20lifestyle%20portrait%20photography%2C%20modern%20and%20warm&width=120&height=120&seq=testimonial-2&orientation=squarish',
    },
    {
      id: 3,
      name: '李老板',
      role: '水果经销商',
      content: '通过水蜜桃视频对接的果园，品质有保障，物流也快。现在我的客户都指定要平台上合作果园的桃子。',
      avatar: 'https://readdy.ai/api/search-image?query=Chinese%20businessman%20in%20his%2040s%2C%20professional%20attire%2C%20confident%20smile%2C%20modern%20office%20background%2C%20corporate%20portrait%20style%2C%20trustworthy%20and%20successful&width=120&height=120&seq=testimonial-3&orientation=squarish',
    },
  ],
};

export const faqs = [
  {
    question: '水蜜桃视频平台的主要内容有哪些？',
    answer: '水蜜桃视频平台涵盖水蜜桃种植技术、果园采摘记录、品种品鉴评测、美食制作教程以及果园实时直播五大核心内容板块。我们通过短视频和图文文章的形式，为用户提供全方位的水蜜桃主题内容。',
  },
  {
    question: '如何在水蜜桃视频上发布自己的内容？',
    answer: '您可以通过水蜜桃视频APP或官网的"创作者中心"注册成为创作者，上传您的水蜜桃相关视频或图文内容。我们的编辑团队会在24小时内完成审核，优质内容将获得首页推荐机会。',
  },
  {
    question: '水蜜桃视频的内容更新频率如何？',
    answer: '我们每天更新至少20条优质短视频内容和5篇深度图文文章。在每年6-8月的水蜜桃旺季，更新量会翻倍，确保用户能获取最新鲜的果园资讯和美食灵感。',
  },
  {
    question: '水蜜桃视频上的果园信息是否可靠？',
    answer: '我们平台对合作果园实行严格的认证审核制度。所有入驻果园均需提供营业执照、果园实拍照片和第三方质量检测报告。同时，我们定期派遣品控团队进行实地考察，确保信息的真实性和可靠性。',
  },
  {
    question: '平台上推荐的水蜜桃品种适合在哪些地区种植？',
    answer: '不同水蜜桃品种对气候和土壤条件有不同要求。白凤和湖景蜜露适合长江中下游地区，朝晖和霞晖适应性较强，可在更广泛的区域种植。我们建议果农根据自己的地理位置和气候条件，参考平台上的种植指导选择合适品种。',
  },
];